import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, NgStyle } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';

import { PlayerData } from '@player/shared/models/player.model';
import { SurveyStore } from '@player/shared/services/survey-store.service';
import { LanguageManager } from '@player/shared/services/language-manager.service';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';

import { BasicModule } from '@shared/modules/basic.module';
import { BrandWordmark } from '@player/shared/components/brand-wordmark/brand-wordmark.component';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'survey-status',
  templateUrl: 'survey-status.component.html',
  styleUrls: ['survey-status.component.scss'],
  providers: [SurveyStore],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, BasicModule, NgStyle, SharedModuleForPlayer, BrandWordmark],
})
export class SurveyStatusComponent implements OnInit {
  readonly http = inject(HttpClient);
  readonly ss = inject(SurveyStore);
  private lm = inject(LanguageManager);

  @Input() icon?: string;

  @Input() translationKey?: string;

  @Input() fallbackText?: string;

  private readonly queryParams = new HttpParams({
    fromString: location.search?.substring(1) || '',
  });

  ngOnInit(): void {
    const revision = window.ZEF ? window.ZEF.revision : Math.random().toString();
    const release = window.ZEF ? window.ZEF.url || '' : 'assets/testing/';
    const location = window.ZEF ? window.ZEF.root || window.ZEF.url || '' : 'assets/testing/';

    this.http
      .get(`${location || release}settings.json?${revision}`)
      .pipe(catchError(() => of({})))
      .subscribe((data: PlayerData) => {
        if (this.queryParams.get('lang')) {
          this.lm.paramsLanguage = this.queryParams.get('lang');
        }

        this.lm.autodetectLanguage = !!data.design?.sidebar?.selectLanguage;
        this.lm.init(data.languages, data.survey?.language, location);

        this.ss.design.next(data.design);
        this.ss.languages.next(data.languages);
      });
  }
}
